<div class="container-integration__fieldset form-filter-fieldset col-12">
    <msc-organize-integration-watch-rules-recap [currentRule]="rule" [navigationIndex]="navigationIndex" [providerName]="providerName" [navigations]="navigations" [large]="true" class="flex center"></msc-organize-integration-watch-rules-recap>
</div>
